module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_102-261fe4bb78c427f3088005f37f123907.png";